"use client";

import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "@/components/ui/accordion";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
interface FaqItem {
  id: string;
  question: string;
  answer: string;
}
const FAQ_ITEMS: FaqItem[] = [{
  id: "item-1",
  question: "How does the City of Decatur permitting process work for residential additions?",
  answer: "All additions in the City of Decatur require building, electrical, plumbing, and mechanical permits submitted through the city's building division. The process includes zoning review, site plan assessment for tree protection and impervious surface limits, and architectural plan review before construction commences."
}, {
  id: "item-2",
  question: "What are the rules if our home is located within a Decatur local historic district?",
  answer: "Properties in designated Decatur historic districts (such as McDonough-Adams-Kings Highway, Old Decatur, or Clairemont Avenue) require a Certificate of Appropriateness (COA) from the Decatur Historic Preservation Commission. Additions must remain subordinate to the original structure, respect historic massing, and use compatible exterior finishes."
}, {
  id: "item-3",
  question: "How do you handle structural and foundation tie-ins on older Decatur homes?",
  answer: "Many older Decatur bungalows and cottages sit on crawlspaces with brick or stone piers. Structural expansion requires engineering the new foundation—whether poured concrete stem wall or crawlspace—with proper expansion joints and rebar tie-ins to prevent uneven settling between the original footprint and the new build."
}, {
  id: "item-4",
  question: "How do zoning setbacks and lot coverage rules affect addition size?",
  answer: "Decatur residential zoning codes enforce strict front, side, and rear setbacks alongside maximum lot coverage and floor-area ratios (FAR). A current boundary and topographic survey determines the exact buildable footprint while protecting mature tree canopies and stormwater drainage paths."
}, {
  id: "item-5",
  question: "How do you match exterior rooflines, siding, and trim to the existing house?",
  answer: "Custom additions maintain visual harmony by replicating existing roof pitches, eave depths, and fascia profiles. We source matching wood or fiber cement lap siding, historic brick patterns, and period-correct window proportions so the addition looks original to the residence."
}];
export default function AdditionFaq() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll<HTMLElement>({
    threshold: 0.15
  });
  return <section id="additionfaq" data-nav="light" ref={ref} className="bg-background text-foreground py-20 md:py-28 px-4 sm:px-6 lg:px-8 border-b border-border/60 transition-opacity duration-700" style={{
    opacity: isVisible ? 1 : 0
  }}>
      <div className="max-w-4xl mx-auto">
        <div className="text-center mb-12 md:mb-16">
          <h2 className="font-serif text-3xl sm:text-4xl lg:text-5xl font-medium tracking-tight text-foreground text-balance">
            Frequently Asked Questions About Home Additions
          </h2>
          <p className="mt-4 text-base sm:text-lg text-muted-foreground max-w-2xl mx-auto font-sans leading-relaxed">
            Essential considerations for expanding your living space in Decatur, from city zoning and historic preservation to structural engineering.
          </p>
        </div>

        <div className="bg-card/70 border border-border/80 rounded-xl p-4 sm:p-8 shadow-sm backdrop-blur-xs">
          <Accordion type="single" collapsible className="w-full">
            {FAQ_ITEMS.map((item, i) => <AccordionItem key={item.id} value={item.id} data-index={i} className="border-border/70 last:border-b-0 py-1">
                <AccordionTrigger className="font-serif text-base sm:text-lg text-foreground hover:text-primary hover:no-underline text-left py-4 px-2 sm:px-3">
                  {item.question}
                </AccordionTrigger>
                <AccordionContent className="font-sans text-sm sm:text-base text-muted-foreground leading-relaxed px-2 sm:px-3 pb-4">
                  {item.answer}
                </AccordionContent>
              </AccordionItem>)}
          </Accordion>
        </div>
      </div>
    </section>;
}